import { InjectionToken } from '@angular/core';
import { ShareableType } from '@bindoc-projects/resource-domain-lib';
import { Observable } from 'rxjs';

export interface BdArchiveShareableRequest {
  shareableType: ShareableType;
  shareableId: string;
  shareableName?: string;
}

/**
 * Opens the archive-confirmation dialog and emits exactly once:
 *  - `true` when the user confirmed,
 *  - `false` when the dialog was cancelled or closed without confirming.
 *
 * The dialog body summarises the shareable's current consumers (users,
 * groups, companies — via folder inheritance and direct grants) so the
 * acting user understands the blast radius of the archive operation.
 *
 * Provided via `provideArchiveShareableDialog()` from
 * `@bindoc-projects/resource-lib/registration`. Apps that don't archive shareables can
 * omit the provider; callers fall back to a plain confirm dialog when the
 * opener is not present.
 */
export type BdArchiveShareableOpener = (
  request: BdArchiveShareableRequest,
) => Observable<boolean>;

export const BD_ARCHIVE_SHAREABLE_OPENER =
  new InjectionToken<BdArchiveShareableOpener>('BD_ARCHIVE_SHAREABLE_OPENER');
